import { useGetPermissionsByIdQuery } from "api/userManagementApi";
import { useMemo } from "react";
import { retrieveUserData } from "redux/authSlice";

export const usePermissions = (permissionKeys: string[]) => {
  const userRoleId = retrieveUserData()?.roleId;

  const { data: permissionsData, isFetching } =
    useGetPermissionsByIdQuery(userRoleId!, {
      skip: !userRoleId,
    });

  const hasPermissions = useMemo(() => {
    return permissionKeys.reduce((acc, key) => {
      acc[key] = permissionsData?.data?.permissions?.includes(key) || false;
      return acc;
    }, {} as Record<string, boolean>);
  }, [permissionKeys, permissionsData]);

  return {
    hasPermissions,
    isFetching,
  };
};